import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from './TranslateService'; // our translate service

@Pipe({
    name: 'translate',
    pure: false
})
export class TranslatePipe implements PipeTransform {

    private currentLang: string;
    // private currentLangObservable: Subject<string>;

    constructor(private _translate: TranslateService) {
        // this.currentLangObservable = _translate.getCurrentLangObserable();
    }

    transform(key: string, args: any[]): any {
        if (!key) {
            return;
        } else {
            return this._translate.getTranslation(key);
        }
    }

}
